import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgPhChat = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 20,
	height: 21,
	viewBox: "0 0 20 21",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M16.875 3.25H3.12502C2.7935 3.25 2.47556 3.3817 2.24114 3.61612C2.00672 3.85054 1.87502 4.16848 1.87502 4.5V17C1.87358 17.2384 1.94101 17.4721 2.06921 17.673C2.19741 17.874 2.38092 18.0336 2.59768 18.1328C2.76286 18.2097 2.94281 18.2497 3.12502 18.25C3.41845 18.2492 3.70213 18.1446 3.9258 17.9547L3.93284 17.9492L6.4844 15.75H16.875C17.2065 15.75 17.5245 15.6183 17.7589 15.3839C17.9933 15.1495 18.125 14.8315 18.125 14.5V4.5C18.125 4.16848 17.9933 3.85054 17.7589 3.61612C17.5245 3.3817 17.2065 3.25 16.875 3.25ZM16.875 14.5H6.25002C6.09995 14.5001 5.95492 14.5542 5.84143 14.6523L3.12502 17V4.5H16.875V14.5Z",
		fill: "#A0A0A0"
	})
});
export default SvgPhChat;
